import { render, staticRenderFns } from "./DuplicateUsers.vue?vue&type=template&id=badef960&scoped=true&"
import script from "./DuplicateUsers.vue?vue&type=script&lang=js&"
export * from "./DuplicateUsers.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateUsers.vue?vue&type=style&index=0&id=badef960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badef960",
  null
  
)

export default component.exports